import { CHARACTERS, CHARACTER_TAGS, PLAYER } from '../data';
import { ASSETS } from '../assetManifest';

export const getTeamData = () => {
  const characters = PLAYER.team.map(characterId => {
    const character = PLAYER.characters.find(c => c.uid === characterId);
    return {
      ...character,
      id: character.uid,
      portrait: ASSETS.characters[character.prototypeId].path,
      stars: character.rarity,
      tags: (character.tags || []).map(tag => ({
        text: tag,
        color: CHARACTER_TAGS[tag].color
      })),
      stats: {
        HP: character.stats.hp,
        ATK: character.stats.attack,
        DEF: character.stats.defense
      },
      elements: character.elements || []
    };
  });

  return {
    characters
  };
};

export const removeCharacterFromTeam = (index) => {
  PLAYER.team.splice(index, 1);
};

export const addCharacterToTeam = (characterId, index) => {
  if (index !== undefined && index < PLAYER.team.length) {
    // Swap
    PLAYER.team[index] = characterId;
  } else {
    // Add new
    PLAYER.team.push(characterId);
  }
};
